import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["overflow-hidden relative w-full", [$props.fullScreen ? 'h-full' : `h-0 ${$options.padding}`]])
  }, [
    _createElementVNode("div", {
      id: $data.videoContainerId,
      class: "object-cover object-center absolute top-0 left-0 w-full h-full",
      innerHTML: $props.embedCode
    }, null, 8, _hoisted_1),
    ($data.firstPlay && $props.fullScreen)
      ? _renderSlot(_ctx.$slots, "default", { key: 0 })
      : _createCommentVNode("", true)
  ], 2))
}